import {defineMessage} from 'react-intl';
import * as React from 'react';
import {buildInstructions} from '../../snippets/dotnet';
import comment from '../../snippets/comment';
import {
  BuildInstructions,
  CreateShellCommand,
} from '../../../components/left-col';

export const steps = {
  setup: {
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.dotnet.setup.heading',
        defaultMessage: 'Install the Stripe.net library',
      }),
    },
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.dotnet.setup.body',
        defaultMessage:
          'Install the package with dotnet or NuGet. Alternatively, if you’re starting from scratch, download the files which contains a configured .csproj file.',
      }),
    },
    Component() {
      return <BuildInstructions instructions={buildInstructions} />;
    },
  },
  create: {},
  customer: {},
  'pass-customer': {},
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.dotnet.charge.body',
        defaultMessage:
          'Run your ASP.NET MVC server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand('dotnet run'),
  },
};

export default ({keys, merchant}) => `using System;
using Microsoft.AspNetCore;
using Microsoft.AspNetCore.Builder;
using Microsoft.AspNetCore.Hosting;
using Microsoft.AspNetCore.Mvc;
using Microsoft.Extensions.DependencyInjection;
using Microsoft.Extensions.Hosting;
using Newtonsoft.Json;
using Stripe;

namespace StripeExample
{
  public class Program
  {
    public static void Main(string[] args)
    {
      WebHost.CreateDefaultBuilder(args)
        .UseUrls("http://0.0.0.0:4242")
        .UseWebRoot("public")
        .UseStartup<Startup>()
        .Build()
        .Run();
    }
  }

  public class Startup
  {
    public void ConfigureServices(IServiceCollection services)
    {
      services.AddMvc().AddNewtonsoftJson();
    }

    public void Configure(IApplicationBuilder app, IWebHostEnvironment env)
    {
      {+setup}
      ${comment && comment(merchant)}
      StripeConfiguration.ApiKey = "${keys.secret}";
      {/setup}

      if (env.IsDevelopment()) app.UseDeveloperExceptionPage();
      app.UseRouting();
      app.UseStaticFiles();
      app.UseEndpoints(endpoints => endpoints.MapControllers());
    }
  }

  [Route("create-payment-intent")]
  [ApiController]
  public class PaymentIntentApiController : Controller
  {
    [HttpPost]
    public ActionResult Create(PaymentIntentCreateRequest request)
    {
      {?save-card customer}
      // Alternatively, set up a webhook to listen for the payment_intent.succeeded event
      // and attach the PaymentMethod to a new Customer
      var customers = new CustomerService();
      var customer = customers.Create(new CustomerCreateOptions());
      {/customer}
      {+create}
      var paymentIntents = new PaymentIntentService();
      var {span response create}paymentIntent{/span} = paymentIntents.Create(new PaymentIntentCreateOptions
      {
        {?save-card pass-customer}
        Customer = customer.Id,
        SetupFutureUsage = "off_session",
        {/pass-customer}
        Amount = CalculateOrderAmount(request.Items),
        Currency = "usd",
      });

      return Json(new { clientSecret = paymentIntent.ClientSecret });
      {/create}
    }

    private int CalculateOrderAmount(Item[] items)
    {
      // Replace this constant with a calculation of the order's amount
      // Calculate the order total on the server to prevent
      // people from directly manipulating the amount on the client
      return 1400;
    }

    {?save-card charge}
    public void ChargeCustomer(string customerId)
    {
      // Lookup the payment methods available for the customer
      var paymentMethods = new PaymentMethodService();
      var availableMethods = paymentMethods.List(new PaymentMethodListOptions
      {
        Customer = customerId,
        Type = "card",
      });

      // Charge the customer and payment method immediately
      var paymentIntents = new PaymentIntentService();
      var paymentIntent = paymentIntents.Create(new PaymentIntentCreateOptions
      {
        Amount = 1099,
        Currency = "usd",
        Customer = customerId,
        PaymentMethod = availableMethods.Data[0].Id,
        OffSession = true,
        Confirm = true
      });

      if (paymentIntent.Status == "succeeded")
        Console.WriteLine("✅ Successfully charged card off session");
    }

    {/charge}
    public class Item
    {
      [JsonProperty("id")]
      public string Id { get; set; }
    }

    public class PaymentIntentCreateRequest
    {
      [JsonProperty("items")]
      public Item[] Items { get; set; }
    }
  }
}`;
